goog.provide("shadow.js.shim.module$date_fns$locale$gl$default");
shadow.js.shim.module$date_fns$locale$gl$default = esm_import$date_fns$locale$gl.default;
